import { render, staticRenderFns } from "./MyShelf.vue?vue&type=template&id=6df889f6&scoped=true"
import script from "./MyShelf.vue?vue&type=script&lang=ts"
export * from "./MyShelf.vue?vue&type=script&lang=ts"
import style0 from "./MyShelf.vue?vue&type=style&index=0&id=6df889f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df889f6",
  null
  
)

export default component.exports